import { createSelector } from '@reduxjs/toolkit';
import { StorageState } from '../../reducers';

const sliceSelector = (state: StorageState) => state.notificationsSending;

export const notificationSendingListSelector = () => createSelector(sliceSelector, state => state.list);
export const notificationSendingLoading = () => createSelector(sliceSelector, state => state.isLoading);
export const notificationSendingLoaded = () => createSelector(sliceSelector, state => state.isLoaded);
